<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div class="card_container" style="border-radius: 17px">
          <div class="card__header___text">
            <div>
              <h3 class="our_branches__header">
                {{ $t("text.branch.totalExpenses") }}
              </h3>
              <div class="dealer__icon__wrapper mt-3">
                <div class="dealer__icon__div text-center">
                  <div>
                    <img src="@/assets/img/category.svg" width="35px" />
                  </div>
                </div>
              </div>
              <div class="text-center mt-3 bold-span">
                <h3>₦{{ totalExpenses }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3 co_order"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner">
            <div class="row align-items-center" style="height: 100%">
              <div class="col-md-6">
                <div class="">
                  <h6 class="text-white ml-5">
                    {{ $route.query.branchName }}
                    {{ $t("text.branch.expenseBreakdown") }}
                    {{
                      this.$route.query.category == "all"
                        ? "All Categories"
                        : `${this.$route.query.category} category`
                    }}
                  </h6>
                </div>
              </div>
              <div class="col-md-3">
                <vue-ctk-date-time-picker
                  v-model="dateRange"
                  :max-date="maxDate"
                  :range="true"
                  :autoClose="true"
                  :locale="this.$root.$i18n.locale"
                  :custom-shortcuts="customShortcuts"
                  color="#4b2d73"
                  format="DDMMYYYY"
                  formatted="DD/MM/YYYY"
                  :label="$t('text.sendReport.dateRange')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 dashboard_first_row">
        <div class="position-relative">
          <ejs-grid
            v-show="!showLoader"
            ref="dataGrid"
            :created="refreshGrid"
            :allowPaging="true"
            :allowSorting="true"
            :pageSettings="pageSettings"
            :toolbar="toolbar"
            :searchSettings="search"
            :allowExcelExport="true"
            :allowPdfExport="true"
            :toolbarClick="toolbarClick"
            :excelQueryCellInfo="excelQueryCellInfo"
            :allowTextWrap="true"
            :locale="usedLang"
          >
            <e-columns>
              <e-column width="70" field="index" headerText="#"></e-column>
              <e-column
                width="200"
                field="date"
                :format="formatOptions"
                type="date"
                :headerText="$t('text.branch.date')"
              ></e-column>
              <e-column
                width="150"
                field="branchName"
                :headerText="$t('text.branch.retailOutlet')"
              ></e-column>
              <e-column
                width="200"
                field="amount"
                format="N2"
                :headerText="$t('text.manageExpenses.amount')"
              ></e-column>
              <e-column
                width="180"
                field="category"
                :headerText="$t('text.branch.cat')"
              ></e-column>
              <e-column
                width="180"
                field="description"
                :headerText="$t('text.branch.desc')"
              ></e-column>
            </e-columns>
          </ejs-grid>
          <TableLoader :showLoader="showLoader" />
        </div>
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Dealer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import CreateAssetGroup from "@/components/modals/Assets/createAssetGroup.vue";
import EditAssetGroup from "@/components/modals/Assets/editAssetGroup.vue";
import Temp from "@/components/TableTemplates/assets/companyAssets.vue";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Dealer Branches Expense Breakdown :: Epump Portal",
  name: "Assets",
  components: {
    MasterLayout,
    CreateAssetGroup,
    EditAssetGroup,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      dealer: null,
      backgroundUrl,
      cardBackgroundUrl,
      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      search: { operator: "contains", ignoreCase: true },
      dealerExpenses: [],
      groupedExpense: [],
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      totalExpenses: 0,
    };
  },
  created() {
    this.$eventHub.$on("dealer", (dealer) => {
      this.dealer = dealer;
    });
    if (this.$route.query.dealerId) {
      this.getExpenses();
    }
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
  },
  beforeDestroy() {},
  watch: {
    dealer(dealer) {
      if (dealer !== null) {
        this.getExpenses();
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getExpenses();
      }
    },
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },
    getExpenses() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Expenses/Dealer/${
            this.$route.query.dealerId
              ? this.$route.query.dealerId
              : this.dealer.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          let data;
          if (
            response.data.companyExpenses &&
            response.data.companyExpenses.length > 0
          ) {
            this.dealerExpenses = response.data.companyExpenses;
            this.groupedExpense = response.data.groupedExpense;

            const catExp =
              this.$route.query.category == "all"
                ? this.dealerExpenses
                : this.groupedExpense.filter(
                    (grpExp) => grpExp.category == this.$route.query.category
                  )[0].expenses;

            const branchExp = catExp.filter(
              (bchExp) => bchExp.branchId == this.$route.query.branchId
            );

            branchExp.forEach((exp, index) => {
              exp.index = index + 1;
              exp.description = exp.description ? exp.description : "N/A";
            });

            this.totalExpenses = this.convertThousand(
              branchExp.reduce((acc, cur) => (acc += cur.amount), 0)
            );

            data = branchExp;
          } else {
            data = [];
            this.totalExpenses = "0.00";
          }

          this.$refs.dataGrid.ej2Instances.setProperties({ dataSource: data });
          this.refreshGrid();
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
